import { Directive, Input } from '@angular/core';

interface TemplateVariableContext<Titem extends object> {
  $implicit: Titem;
}

// This directive is used to type the items in a table row. They are any by default, which is error-prone.
@Directive({
  selector: 'ng-template[typedTemplateVariable]',
})
export class TypedTemplateVariableDirective<Titem extends object> {
  @Input('typedTemplateVariable') items!: Titem[];

  static ngTemplateContextGuard<TContextItem extends object>(
    dir: TypedTemplateVariableDirective<TContextItem>,
    ctx: unknown,
  ): ctx is TemplateVariableContext<TContextItem> {
    return true;
  }
}
